import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@resideo/blueprint-oneportal";
import styles from "./WelcomeOverlay.module.css";

export interface WelcomeOverlayProps {
  onGetStarted: () => void;
}

/**
 * Full-screen onboarding overlay shown once after a user's first login.
 */
export const WelcomeOverlay: React.FC<WelcomeOverlayProps> = ({
  onGetStarted,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={styles.overlay}
      role="dialog"
      aria-modal="true"
      aria-labelledby="welcome-overlay-title"
      data-testid="welcome-overlay"
    >
      <div className={styles.content}>
        <h1 id="welcome-overlay-title" className={styles.title}>
          {t("welcomeOnboarding.title")}
        </h1>
        <p className={styles.subtitle}>
          {t("welcomeOnboarding.subtitle")}
        </p>
        <Button
          type="button"
          variant="primary"
          autoFocus
          className={styles.button}
          onClick={onGetStarted}
          data-testid="welcome-overlay-get-started"
        >
          {t("welcomeOnboarding.getStarted")}
        </Button>
      </div>
    </div>
  );
};

export default WelcomeOverlay;
